import { useEffect, useState } from "react";
import { BsLink45Deg } from "react-icons/bs";
import { HiOutlineMailOpen } from "react-icons/hi";
import { RiEditLine } from "react-icons/ri";
import { AiOutlineQrcode, AiOutlineShareAlt } from "react-icons/ai";
import InputCopy from "../../../components/inputCopy";
import TemplateCopy from "../../../components/templateCopy";
import SignatureCopy from "../../../components/signatureCopy";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useParams } from "react-router-dom";
import { getDetailCampaign } from "../../../store/campaign";
import Codeqr from "../../../components/CodeQr";
import Loadingimg from "../../../statics/illustrations/sand-clock.svg";
import Error from "../../../components/error";
import { ErrorType } from "../../../store/errorType";
import InputCopySocial from "../../../components/inputCopy/inputCopySocial";
/* baja */
import Fwyauto from "./fwyAuto";
import Bajaauto from "./bajaAuto";
import Socialauto from "./fwyAuto/socialAuto";
import Socialbaja from "./bajaAuto/socialBaja";
import Socialcostuless from "./costuLess/socialCostuLess";
import Socialuseagencies from "./useAgencies/socialUseAgencies";
import Socialvernfonk from "./vernFonk/socialVernFonk";
import Socialinsureone from "./insureOne/socialInsureOne";
import Flyercostuless from "./costuLess/flyerCostuLess";
import Flyerusaagencies from "./useAgencies/flyerUsaAgencies";
import Flyervernfonk from "./vernFonk/flyerVernfonk";
import Flyerinsureone from "./insureOne/flyerInsureone";
import Flyerssegurosinbarreras from "./seguroSinBarrereas/flyerSseguroSinBarreras";
import Flyersoh from "./soh/flyerSoh";
import Flyeroasis from "./oasis/flyerOasis";
import Socialsegurosinbarreras from "./seguroSinBarrereas/socialSeguroSinBarreras";
import Socialsoh from "./soh/socialSoh";
import Socialoasis from "./oasis/socialOasis";
import Codelocked from "../../../components/CodeQr/codeLocked";
import Codeqrgenerate from "../../../components/CodeQr/codeQRGenerate";
import { FaRegStickyNote } from "react-icons/fa";
import Stikersgenerate from "../../../components/CodeQr/stikersGenerate";
import { refreshtoken, sesisonExpired } from "../../../store/user";
import Stickersbussinescard from "../../../components/CodeQr/stickersBussinesCard";
import useFetchtoken from "../../../customHooks/useFetchToken";
import FlyerAcceptance from "./acceptance/flyerAcceptance";
import SocialAcceptance from "./acceptance/socialAcceptance";

const Detailcampaign = () => {
  // const QA = process.env.REACT_APP_QA
  const dispatch = useAppDispatch();
  const { id_employee } = useAppSelector((state) => state.user);
  const { detail, status, errorMessage, errorType } = useAppSelector(
    (state) => state.campaign
  );

  const { id_campaign } = useParams();
  const [state, setstate] = useState<number>(0);

  const campaign = id_campaign ? id_campaign : "";
  const promise = useFetchtoken(
    getDetailCampaign({ id_campaign: campaign, id_employee })
  );

  /* useEffect(() => {
    const promise = dispatch(getDetailCampaign({ id_campaign:campaign , id_employee }))

    promise.then((response:any)=>{
      if(response.error?.message === 'Request failed with status code 508'){
        dispatch(sesisonExpired())
        return null;
      }
      if (response.meta.requestStatus === 'fulfilled'){
        dispatch(refreshtoken())
        return null;
      }
    })

    return () => {
     promise.abort()
    }
  }, []) */

  if (status === "getDetailCampaign_loading") {
    return (
      <div className="c-skeleton-detail-campaign">
        {/* <div className="c-skeleton-detail-campaign__tabs"/>
        <span className="c-skeleton-detail-campaign__title"/>
        <div className="c-skeleton-detail-campaign__content"/>
        <span className="c-skeleton-detail-campaign__title"/>
        <div className="c-skeleton-detail-campaign__content"/> */}
        <div className="c-skeleton-detail-campaign__box-message">
          <img
            src={Loadingimg}
            alt="imagen loading"
            className="c-skeleton-detail-campaign__img"
          />
          <span className="c-skeleton-detail-campaign__message">
            We are now generating your PURLs!
          </span>
          <span className="c-skeleton-detail-campaign__message">
            This process may take up to 15 seconds.
          </span>
          <span className="c-skeleton-detail-campaign__message">
            Please do not refresh the page
          </span>
        </div>
      </div>
    );
  }

  if (status === "getDetailCampaign_rejected") {
    return (
      <>
        {errorType === ErrorType.ERROR_SERVER && (
          <Error type="error" message={errorMessage} />
        )}
        {errorType === ErrorType.ERROR_PERMISSION && (
          <Error type="problem" message={errorMessage} />
        )}
      </>
    );
  }

  return (
    <div className="c-detail-campaign">
      <div className="c-detail-campaign__tabs">
        <span
          className={`c-detail-campaign__tab ${
            state === 0 && `c-detail-campaign__tab--active`
          }`}
          onClick={() => setstate(0)}
        >
          <BsLink45Deg />
          <span className="c-detail-campaign__text">Links</span>
        </span>

        <span
          className={`c-detail-campaign__tab ${
            state === 1 && `c-detail-campaign__tab--active`
          }`}
          onClick={() => setstate(1)}
        >
          <HiOutlineMailOpen />
          <span className="c-detail-campaign__text">Templates</span>
        </span>

        <span
          className={`c-detail-campaign__tab ${
            state === 2 && `c-detail-campaign__tab--active`
          }`}
          onClick={() => setstate(2)}
        >
          <RiEditLine />
          <span className="c-detail-campaign__text">Email Signature</span>
        </span>
        <span
          className={`c-detail-campaign__tab ${
            state === 3 && `c-detail-campaign__tab--active`
          }`}
          onClick={() => setstate(3)}
        >
          <AiOutlineQrcode />
          <span className="c-detail-campaign__text">QR Code</span>
        </span>
        <span
          className={`c-detail-campaign__tab ${
            state === 4 && `c-detail-campaign__tab--active`
          }`}
          onClick={() => setstate(4)}
        >
          <AiOutlineShareAlt />
          <span className="c-detail-campaign__text">Social Sharing </span>
        </span>
        <span
          className={`c-detail-campaign__tab ${
            state === 5 && `c-detail-campaign__tab--active`
          }`}
          onClick={() => setstate(5)}
        >
          <FaRegStickyNote />
          <span className="c-detail-campaign__text">Stickers </span>
        </span>
      </div>

      <div className="c-detail-campaign__content">
        {state === 0 && (
          <>
            {/* <InputCopy text="Link" value={`${detail.link}?utm_medium=long_link`} />
            <InputCopy text="Short Link (Preferred)" value={detail.short_link} /> */}
            <InputCopy text="Link" value={detail.short_link} />
          </>
        )}

        {state === 1 && (
          <div className="link-templates">
            <TemplateCopy
              text="English Email Template"
              value={detail.link}
              es={false}
              campaign={detail.code}
              template={detail.email_template.en}
            />
            <TemplateCopy
              text="Spanish Email Template"
              value={detail.link}
              es={true}
              campaign={detail.code}
              template={detail.email_template.es}
            />
          </div>
        )}

        {state === 2 && (
          <div className="email-signature">
            <SignatureCopy
              text="Email Signature A"
              value={detail.email_signature[0]}
            />
            <SignatureCopy
              text="Email Signature B"
              value={detail.email_signature[1]}
            />
          </div>
        )}

        {state === 3 && (
          <>
            {/* <div className="c-code-qr">
            {
              detail.link_qr_png ?
                <Codeqr
                  url={detail.link_qr_png}
                  pdf={detail.link_qr_pdf}
                  black_white={false}
                  id_campaign={id_campaign}
                />
              :
                <Codelocked
                  title="Color QR Code"
                  endpoint="/api/purls/employee/campaigns/png/en/one"
                  id_campaign={id_campaign}
                  black_white={false}
                  url={detail.link_qr_svg}
                  text_download="Download QR Code"
                  text_download_bw="Dowload Color QR Code Cut outs"
                />
            }
            {
                detail.link_qr_png_bw ?
                  <Codeqr
                    url={detail.link_qr_png_bw}
                    pdf={detail.link_qr_pdf}
                    black_white={true}
                    pdf_black_white={detail.link_qr_pdf_bw}
                    id_campaign={id_campaign}
                  />
                  :
                  <Codelocked
                    title="Black&White QR Code"
                    endpoint="/api/purls/employee/campaigns/png/en/one-bw"
                    id_campaign={id_campaign}
                    black_white={true}
                    url={detail.link_qr_svg}
                    text_download="Download Black&White QR Code"
                    text_download_bw="Download Black&White QR Code Cut outs"
                  />
            }
          </div> */}
            <div className="c-detail-campaign__title">
              QR Code, Flyers or Business Card Image
            </div>
            <div className="c-detail-campaign__subtitle">
              Download or Print: QR Code, Flyers or Business Card Image
            </div>
            <div className="c-detail-campaign__title-section">QR Code</div>
            <div className="c-code-qr">
              <Codeqrgenerate
                svg={detail.link_qr_svg}
                id_campaign={campaign}
                black_white={false}
              />
              <Codeqrgenerate
                svg={detail.link_qr_svg}
                id_campaign={campaign}
                black_white={true}
              />
            </div>

            <hr className="c-detail-campaign__line" />
            <div className="c-detail-campaign__title-section">
              QR Code for Business Cards
            </div>
            <div className="c-detail-campaign__subtitle">
              Business Cards will need to be ordered in Office Depot. This only
              provides you the ability to download the image, you will need to
              add to your business card template in Office Depot. Please be sure
              to save the image to your desktop.
            </div>
            <div className="c-code-qr">
              <Stickersbussinescard
                id_campaign={campaign}
                black_white={false}
              />
              <Stickersbussinescard 
                id_campaign={campaign} 
                black_white={true} />
            </div>

            <hr className="c-detail-campaign__line" />
            <div className="c-detail-campaign__title-section">
              QR Code Flyer
            </div>
            {detail.code === "auto" && detail.brand === "FWY" && (
              <Fwyauto id_campaign={campaign} id_employee={id_employee} />
            )}

            {detail.code === "auto" && detail.brand === "BAJA" && (
              <Bajaauto id_campaign={campaign} id_employee={id_employee} />
            )}
            {detail.code === "auto" && detail.brand === "CUL" && (
              <Flyercostuless
                id_campaign={campaign}
                id_employee={id_employee}
              />
            )}
            {detail.code === "auto" && detail.brand === "USA" && (
              <Flyerusaagencies
                id_campaign={campaign}
                id_employee={id_employee}
              />
            )}
            {detail.code === "auto" && detail.brand === "VERNFONK" && (
              <Flyervernfonk id_campaign={campaign} id_employee={id_employee} />
            )}
            {detail.code === "auto" && detail.brand === "INO" && (
              <Flyerinsureone
                id_campaign={campaign}
                id_employee={id_employee}
              />
            )}
            {detail.code === "auto" && detail.brand === "SSB" && (
              <Flyerssegurosinbarreras
                id_campaign={campaign}
                id_employee={id_employee}
              />
            )}
            {detail.code === "auto" && detail.brand === "SOH" && (
              <Flyersoh id_campaign={campaign} id_employee={id_employee} />
            )}
            {detail.code === "auto" && detail.brand === "OASIS" && (
              <Flyeroasis id_campaign={campaign} id_employee={id_employee} />
            )}
            {detail.code === "auto" && detail.brand === "ACC" && (
              <FlyerAcceptance
                id_campaign={campaign} 
                id_employee={id_employee} />
            )}
          </>
        )}
        {state === 4 && (
          <>
            <InputCopySocial
              title="Social Media URL and Graphics"
              value={detail.short_link}
              description="You will need to use the specified PURLs for social media. The Link can be shared on all social media plaftorms."
              descriptionInput="Link"
            />
            {detail.code === "auto" && detail.brand === "FWY" && <Socialauto />}
            {detail.code === "auto" && detail.brand === "BAJA" && (
              <Socialbaja />
            )}
            {detail.code === "auto" && detail.brand === "CUL" && (
              <Socialcostuless />
            )}
            {detail.code === "auto" && detail.brand === "USA" && (
              <Socialuseagencies />
            )}
            {detail.code === "auto" && detail.brand === "VERNFONK" && (
              <Socialvernfonk />
            )}
            {detail.code === "auto" && detail.brand === "INO" && (
              <Socialinsureone />
            )}
            {detail.code === "auto" && detail.brand === "SSB" && (
              <Socialsegurosinbarreras />
            )}
            {detail.code === "auto" && detail.brand === "SOH" && <Socialsoh />}
            {detail.code === "auto" && detail.brand === "OASIS" && (
              <Socialoasis />
            )}
            {detail.code === "auto" && detail.brand === "ACC" && (
              <SocialAcceptance />
            )}
          </>
        )}
        {state === 5 && (
          <>
            <div className="c-detail-campaign__title">QR Stickers</div>
            <div className="c-detail-campaign__subtitle">
              You will need to go to Office Depot to purchase stickers. Labels
              (stickers) will need to be approved by your manager for purchase.
            </div>
            <div className="c-detail-campaign__subtitle">
              The Label Template is: Avery Easy Peel True Block
              Print-To-The-Edge Inkjet/Laser Labels, 22805 1 1/2" x 1 1/2",
              Matte White, Pack of 600 (Item#187243)
            </div>
            <div className="c-code-qr">
              <Stikersgenerate
                brand_img={detail.brand}
                id_campaign={campaign}
                title="QR Stickers"
                titleButtonOne="Download Color QR Stickers"
                endpoint="/api/purls/employee/campaigns/sticker/en/one"
                black_white={false}
              />
              <Stikersgenerate
                brand_img={detail.brand}
                id_campaign={campaign}
                title="Black & White QR Stickers "
                titleButtonOne="Download Black & White QR Stickers"
                endpoint="/api/purls/employee/campaigns/sticker/en/one-bw"
                black_white={true}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Detailcampaign;
